import {
  ConditionalRender,
  CustomizedButton,
  CustomizedTypography
} from '@components/Customized';
import { ShippingDataModel } from '@generated/graphql';
import { ExtensionPaymentDateModal } from '@routes/Payment/component';
import { formatDate } from '@utils/formatter';
import { ProgressInfoDateWithButton } from '../ProgressInfoDateWithButton';
import { ProgressInfoReason } from '../ProgressInfoReason';
import { ProgressInfoBottomItemCommonProps } from './types';

interface ShippingProps extends ProgressInfoBottomItemCommonProps {
  shipping?: ShippingDataModel[];
}

const Shipping: React.FunctionComponent<ShippingProps> = ({
  shipping,
  payment
}) => {
  const lastestShipping = shipping?.[0];

  if (!lastestShipping) return null;

  const isExtended = lastestShipping?.isExtended ?? false;
  const reason = lastestShipping?.extendReason ?? '';
  const title = isExtended
    ? '자동 구매확정일 (구매확정일 연장)'
    : '자동 구매확정일';
  const payoutDate = formatDate(
    lastestShipping?.registerExpectedDate ?? '',
    'YYYY.MM.DD'
  );
  const date = isExtended ? `${payoutDate} 까지 연장` : payoutDate;

  return (
    <>
      <ProgressInfoDateWithButton
        title={title}
        date={date}
        button={
          <ExtensionPaymentDateModal
            expectedPaymentApproveDate={
              lastestShipping?.registerExpectedDate ?? ''
            }
            paymentApproveDateAfterExtended={
              lastestShipping.extendedPurchaseConfirmDate
            }
            purchaseOrderId={payment?.purchaseOrderId ?? ''}
            rfqId={payment?.rfqId}
            quotationPartnerId={payment?.quotationPartnerId}
            openButton={(onClick) => (
              <CustomizedButton
                onClick={onClick}
                variant="contained"
                size="small"
                color="default"
                disabled={isExtended}
              >
                <CustomizedTypography
                  variant="body2"
                  fontWeight="500"
                  color={!isExtended ? 'textPrimary' : 'inherit'}
                >
                  자동 구매확정일 연장
                </CustomizedTypography>
              </CustomizedButton>
            )}
          />
        }
      />
      <ConditionalRender visible={isExtended}>
        <ProgressInfoReason
          reasonTitle={'구매확정일 연장 사유'}
          reasonDescription={reason}
        />
      </ConditionalRender>
    </>
  );
};

export default Shipping;
